var _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g, _rect, _rect2, _rect3, _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 605.71429,
    cy: 486.64789,
    gradientTransform: "matrix(.02891661 0 0 .01235294 26.973101 38.470848)",
    gradientUnits: "userSpaceOnUse",
    r: 117.14286,
    xlinkHref: "#b"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 605.71429,
    cy: 486.64789,
    gradientTransform: "matrix(-.0289166 0 0 .01235294 21.026894 38.470848)",
    gradientUnits: "userSpaceOnUse",
    r: 117.14286,
    xlinkHref: "#b"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(.08449704 0 0 .01235294 -6.539646 38.470822)",
    gradientUnits: "userSpaceOnUse",
    x1: 302.85715,
    x2: 302.85715,
    y1: 366.64789,
    y2: 609.50507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1.1621621 0 0 .91891888 -3.891894 4.445949)",
    gradientUnits: "userSpaceOnUse",
    x1: 40.290417,
    x2: 40.290417,
    y1: 6.093005,
    y2: 41.843941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04168307,
    stopColor: "#fff",
    stopOpacity: 0.235294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96375686,
    stopColor: "#fff",
    stopOpacity: 0.156863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.392157
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(1.1500002 0 0 1.1666666 -.150004 17.333333)",
    gradientUnits: "userSpaceOnUse",
    x1: 10,
    x2: 20,
    y1: -3,
    y2: 12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(1.0327681 0 0 .99872074 -1.29134 -5.518882)",
    gradientUnits: "userSpaceOnUse",
    x1: 23.25,
    x2: 23.25,
    y1: -28.809029,
    y2: 70.294914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6 43h40.799999v3h-40.799999z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.6 43.00013v2.999835c-1.4891338.005647-3.6-.672111-3.6-1.500111 0-.827998 1.6617608-1.499723 3.6-1.499724z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.4 43.00013v2.999835c1.489133.0056 3.6-.672111 3.6-1.500111 0-.827998-1.661761-1.499723-3.6-1.499724z",
    fill: "url(#a)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    height: 36,
    rx: 3,
    width: 45,
    x: 1.5,
    y: 8.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 36,
    opacity: 0.5,
    rx: 3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 45,
    x: 1.5,
    y: 8.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 34,
    opacity: 0.25,
    rx: 2,
    stroke: "url(#e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 43,
    x: 2.5,
    y: 9.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 26.5,
    fill: "#f79e1b",
    r: 8.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 26.5,
    fill: "#eb001b",
    r: 8.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.001953 19.638672a8.5 8.5 0 0 0 -3.501953 6.861328 8.5 8.5 0 0 0 3.498047 6.861328 8.5 8.5 0 0 0 3.501953-6.861328 8.5 8.5 0 0 0 -3.498047-6.861328z",
    fill: "#ff5f00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 8.5c-1.662 0-3 1.338-3 3v17.333984l45-14.980468v-2.353516c0-1.662-1.338-3-3-3z",
    fill: "url(#f)",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.13b427e68842f2175e8056cc93d736f8.svg";
export { ForwardRef as ReactComponent };